import type { Counters } from "../state/store";

type Props = {
  counters: Counters;
};

export function CounterHeader({ counters }: Props) {
  const fresh = counters.total - counters.mastered - counters.inProgress - counters.wrong;
  return (
    <div className="grid grid-cols-5 gap-1.5 text-sm">
      <Cell label="Gesamt" value={counters.total} tone="neutral" />
      <Cell label="Neu" value={fresh} tone="muted" />
      <Cell label="Läuft" value={counters.inProgress} tone="warning" />
      <Cell label="Falsch" value={counters.wrong} tone="danger" />
      <Cell label="Fertig" value={counters.mastered} tone="success" />
    </div>
  );
}

const TONE: Record<string, string> = {
  neutral: "text-fg",
  muted: "text-fg-muted",
  warning: "text-warning",
  danger: "text-danger",
  success: "text-success",
};

function Cell({ label, value, tone }: { label: string; value: number; tone: keyof typeof TONE }) {
  return (
    <div
      data-testid="counter-cell"
      data-counter-label={label}
      className="bg-card/70 rounded-lg px-1.5 py-2 border border-outline-soft text-center"
    >
      <div
        data-counter-value
        className={`text-lg sm:text-xl font-semibold tabular ${TONE[tone]}`}
      >
        {value}
      </div>
      <div className="text-[10px] sm:text-[11px] uppercase tracking-wide text-fg-faint">
        {label}
      </div>
    </div>
  );
}
